<template>
  <v-container fluid>
    <div style="color: #84818A; text-align: center; font-size: 14px;">
      <hr />
      <div style="padding: 15px;">
        Supported formats: KML, Shapefile (Zip containing a .shx, .shp and .dbf) GeoJSON
      </div>
    </div>
    <v-row class="ma-0">
      <v-btn class="text-none" style="border-radius: 8px; color: white; font-size: 16px;" color="#00B3FF" block large
        :loading="isImporting" @click="onImportClick">
        <v-row justify="center" align="center" class="ma-0">
          <svg width="25" height="25" viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg">
            <g clip-path="url(#clip0_2230_68522)">
              <path
                d="M14.5 3.17871V7.17871C14.5 7.44393 14.6054 7.69828 14.7929 7.88582C14.9804 8.07335 15.2348 8.17871 15.5 8.17871H19.5"
                stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
              <path
                d="M17.5 21.1787H7.5C6.96957 21.1787 6.46086 20.968 6.08579 20.5929C5.71071 20.2179 5.5 19.7091 5.5 19.1787V5.17871C5.5 4.64828 5.71071 4.13957 6.08579 3.7645C6.46086 3.38942 6.96957 3.17871 7.5 3.17871H14.5L19.5 8.17871V19.1787C19.5 19.7091 19.2893 20.2179 18.9142 20.5929C18.5391 20.968 18.0304 21.1787 17.5 21.1787Z"
                stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
              <path d="M12.5 11.1787V17.1787" stroke="white" stroke-width="2" stroke-linecap="round"
                stroke-linejoin="round" />
              <path d="M10 13.6787L12.5 11.1787L15 13.6787" stroke="white" stroke-width="2" stroke-linecap="round"
                stroke-linejoin="round" />
            </g>
            <defs>
              <clipPath id="clip0_2230_68522">
                <rect width="24" height="24" fill="white" transform="translate(0.5 0.178711)" />
              </clipPath>
            </defs>
          </svg>
          <span style="margin-left: 10px;">Import Areas</span>
        </v-row>
      </v-btn>
      <input type="file" multiple accept=".zip,.kml,.kmz,.geojson" ref="file-input" @change="onFileInputChange"
        class="d-none">
    </v-row>
  </v-container>
</template>

<script>
import { forEach } from "lodash/collection"
import { importField } from "../../../../api/api-project"
import { FEATURE_GROUPS } from "../../../../helpers/leaflet/constants"

const _Map = Symbol.for("_Map")
const _Processing = Symbol.for("_Processing")

export default {
  name: "FieldImport",
  inject: { _Map, _Processing },
  data: () => ({
    isImporting: false,
  }),
  methods: {
    onImportClick() {
      this.$refs["file-input"].click()
    },
    onFileInputChange(event) {
      this.isImporting = true
      this.importFieldsHandler(Array.from(event.target.files))
    },
    importFieldsHandler(filesArr) {
      const importFieldsPromiseList = []
      forEach(filesArr, file => {
        importFieldsPromiseList.push(
          importField(this.$apiAuth.getAuthToken(), this.Processing["id_processing"], file)
            .then(res => {
              const field = res.data.data
              window.L.HorusLeaflet.field(field, {}, this.Map, true)
                .addTo(this.Map.featureGroups[FEATURE_GROUPS.FEATURES])
            })
        )
      })
      Promise.all(importFieldsPromiseList)
        .finally(() => {
          this.isImporting = false
          this.$refs["file-input"].value = null
        })
    },
  },
  computed: {
    Map() {
      return this._Map()
    },
    Processing() {
      return this._Processing()
    },
  },
}
</script>

<style scoped lang="scss"></style>
